import "./app.postcss";
import "./style.css";
import App from "./App.svelte";
import { initializeGlobalErrorHandling } from "./lib/globalErrorHandler";
import { errorTracker } from "lib";
import { apiUrl } from "./lib/constants";

// Initialize error tracking
initializeGlobalErrorHandling();

// Configure error tracker (you can adjust these settings)
errorTracker.updateConfig({
  enabled: true,
  enableConsoleLogging: import.meta.env.DEV, // Only log to console in development
  maxStoredErrors: 50,
  endpoint: `${apiUrl}/error-tracker`, // Error collection endpoint
});

const app = new App({
  target: document.getElementById("app")!,
});

export default app;
